import { env } from '@edge/env'
import { hotjar } from 'react-hotjar'

const hotjarId = env.REACT_APP_HOTJAR_ID
const hotjarSnippetVersion = env.REACT_APP_HOTJAR_SNIPPET_VERSION

export const hotjarInitialize = (): void => {
    if (hotjarId && hotjarSnippetVersion) {
        hotjar.initialize(hotjarId, hotjarSnippetVersion)
    }
}

export default hotjarInitialize
